import React from "react"
import { useTranslation } from "react-i18next"
import { Typography, styled } from "@mui/material"

type Props = {
  reference_number: string
  children: React.ReactNode
}

const TitleComponent = ({ reference_number, children }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Typography
        variant="h6"
        dangerouslySetInnerHTML={{
          __html: t("features.debt.title", { reference_number }),
        }}
      />
      <Title variant="h6" />
      <Title variant="h3">{children}</Title>
    </>
  )
}

export default TitleComponent

const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.375rem",
  },
}))
